import DataTable from "./table"
import { GridColDef } from "@mui/x-data-grid";

interface UnpaidClientDataTableProps {
    columns: GridColDef[];
    message: string;
    minHeight: number;
}

const UnpaidClientDataTable = ({ columns, message, minHeight }: UnpaidClientDataTableProps) => {
    return (
        <DataTable
            data={[]}
            fieldsNames={columns}
            minHeight={minHeight}
            noDataMessage={message}
            currentPage={1}
            totalItems={10}
            itemsPerPage={10}
            ssrFilter={false}
            isLoading={false}
        />);
}

export default UnpaidClientDataTable;